import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'emailMessage';

const emailMessageService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },
};

export default emailMessageService;
